import React from 'react'

import {
    StyledFeatureComposition,
    StyledMain,
    StyledSidebar,
    StyledAside,
} from 'component-library/compositions/FeatureComposition/FeatureComposition.styled'
import { BaseCompositionProps } from '../types'
import { ThemeMarginKeys, ContainerWidth } from 'component-library/__styling/settings/metrics'

export interface FeatureCompositionProps extends BaseCompositionProps {
    mainContent: React.ReactElement<any>
    sidebarContent: React.ReactElement<any>
    skinnyContent: React.ReactElement<any>
    hasTopSpacing?: boolean
    hasBackgroundFill?: boolean
    /** If true or undefined, will default to the outer margin of the theme */
    horizontalGutters?: boolean | ThemeMarginKeys
    /** If true or undefined, will default to the outer margin of the theme */
    verticalGutters?: boolean | ThemeMarginKeys
    verticalSpacing?: ThemeMarginKeys
    containerWidth?: ContainerWidth
    horizontalGap?: ThemeMarginKeys
}

export type Props = FeatureCompositionProps

export const FeatureComposition: React.FC<Props> = ({
    mainContent,
    sidebarContent,
    skinnyContent,
    hasBackgroundFill,
    horizontalGutters,
    verticalGutters,
    verticalSpacing,
    horizontalGap,
}) => {
    return (
        <StyledFeatureComposition
            horizontalGutters={horizontalGutters}
            verticalGutters={verticalGutters}
            verticalSpacing={verticalSpacing}
            horizontalGap={horizontalGap}
        >
            <StyledAside horizontalGap={horizontalGap}>{skinnyContent}</StyledAside>
            <StyledMain hasBackgroundFill={hasBackgroundFill}>{mainContent}</StyledMain>
            <StyledSidebar horizontalGap={horizontalGap}>{sidebarContent}</StyledSidebar>
        </StyledFeatureComposition>
    )
}
